/**
 * Biker BFF API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import CustomersIdActivatePost200Response from '../model/CustomersIdActivatePost200Response';
import CustomersIdCommunicationpreferencesCommunicationpreferenceIdPutRequest from '../model/CustomersIdCommunicationpreferencesCommunicationpreferenceIdPutRequest';
import CustomersIdCommunicationpreferencesGet200ResponseInner from '../model/CustomersIdCommunicationpreferencesGet200ResponseInner';
import CustomersIdGet200Response from '../model/CustomersIdGet200Response';
import CustomersIdPaymenthistoryGet200ResponseInner from '../model/CustomersIdPaymenthistoryGet200ResponseInner';
import CustomersIdTicketPost200Response from '../model/CustomersIdTicketPost200Response';
import CustomersIdTicketPostRequest from '../model/CustomersIdTicketPostRequest';
import CustomersPostRequest from '../model/CustomersPostRequest';
import CustomersRegisterPost201Response from '../model/CustomersRegisterPost201Response';
import CustomersRegisterPostRequest from '../model/CustomersRegisterPostRequest';
import CustomersSubscriptionGet200Response from '../model/CustomersSubscriptionGet200Response';
import CustomersSubscriptionsActivatePost200Response from '../model/CustomersSubscriptionsActivatePost200Response';
import CustomersSubscriptionsActivatePost400Response from '../model/CustomersSubscriptionsActivatePost400Response';
import CustomersSubscriptionsActivatePost500Response from '../model/CustomersSubscriptionsActivatePost500Response';
import CustomersSubscriptionsActivatePostRequest from '../model/CustomersSubscriptionsActivatePostRequest';
import CustomersSubscriptionsChangePlanGet200Response from '../model/CustomersSubscriptionsChangePlanGet200Response';
import CustomersSubscriptionsPendingGet200Response from '../model/CustomersSubscriptionsPendingGet200Response';
import CustomersSubscriptionsRegisterPut200Response from '../model/CustomersSubscriptionsRegisterPut200Response';
import CustomersSubscriptionsRegisterPut500Response from '../model/CustomersSubscriptionsRegisterPut500Response';
import CustomersSubscriptionsRegisterPutRequest from '../model/CustomersSubscriptionsRegisterPutRequest';
import UpdateSubscription200Response from '../model/UpdateSubscription200Response';
import UpdateSubscription400Response from '../model/UpdateSubscription400Response';
import UpdateSubscription500Response from '../model/UpdateSubscription500Response';
import UpdateSubscriptionRequest from '../model/UpdateSubscriptionRequest';

/**
* Customers service.
* @module api/CustomersApi
* @version 1.0.0
*/
export default class CustomersApi {

    /**
    * Constructs a new CustomersApi. 
    * @alias module:api/CustomersApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }



    /**
     * Initiate subscription activation with hosted payment
     * Verifies the customer has a pending (unactivated) signup, builds an activation basket with the ESIMGO-ACTIVATE-SUBSCRIPTION product and their chosen plan, and returns a hosted payment URL for the customer to complete payment. 
     * @param {String} id The customer ID returned at login
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/CustomersIdActivatePost200Response} and HTTP response
     */
    customersIdActivatePostWithHttpInfo(id) {
      let postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling customersIdActivatePost");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = CustomersIdActivatePost200Response;
      return this.apiClient.callApi(
        '/customers/{id}/activate', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Initiate subscription activation with hosted payment
     * Verifies the customer has a pending (unactivated) signup, builds an activation basket with the ESIMGO-ACTIVATE-SUBSCRIPTION product and their chosen plan, and returns a hosted payment URL for the customer to complete payment. 
     * @param {String} id The customer ID returned at login
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/CustomersIdActivatePost200Response}
     */
    customersIdActivatePost(id) {
      return this.customersIdActivatePostWithHttpInfo(id)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * Get a specific communication preference for customer
     * Proxies `GET /customers/{customerId}/communicationpreferences/{communicationpreferenceId}` to SSB
     * @param {Number} id Customer ID
     * @param {Number} communicationpreferenceId Communication Preference ID
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/CustomersIdCommunicationpreferencesGet200ResponseInner} and HTTP response
     */
    customersIdCommunicationpreferencesCommunicationpreferenceIdGetWithHttpInfo(id, communicationpreferenceId) {
      let postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling customersIdCommunicationpreferencesCommunicationpreferenceIdGet");
      }
      // verify the required parameter 'communicationpreferenceId' is set
      if (communicationpreferenceId === undefined || communicationpreferenceId === null) {
        throw new Error("Missing the required parameter 'communicationpreferenceId' when calling customersIdCommunicationpreferencesCommunicationpreferenceIdGet");
      }

      let pathParams = {
        'id': id,
        'communicationpreferenceId': communicationpreferenceId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = CustomersIdCommunicationpreferencesGet200ResponseInner;
      return this.apiClient.callApi(
        '/customers/{id}/communicationpreferences/{communicationpreferenceId}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Get a specific communication preference for customer
     * Proxies `GET /customers/{customerId}/communicationpreferences/{communicationpreferenceId}` to SSB
     * @param {Number} id Customer ID
     * @param {Number} communicationpreferenceId Communication Preference ID
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/CustomersIdCommunicationpreferencesGet200ResponseInner}
     */
    customersIdCommunicationpreferencesCommunicationpreferenceIdGet(id, communicationpreferenceId) {
      return this.customersIdCommunicationpreferencesCommunicationpreferenceIdGetWithHttpInfo(id, communicationpreferenceId)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * Update a communication preference for customer
     * Proxies `PUT /customers/{customerId}/communicationpreferences/{communicationpreferenceId}` to SSB
     * @param {Number} id Customer ID
     * @param {Number} communicationpreferenceId Communication Preference ID
     * @param {module:model/CustomersIdCommunicationpreferencesCommunicationpreferenceIdPutRequest} customersIdCommunicationpreferencesCommunicationpreferenceIdPutRequest Communication preference details to update
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/CustomersIdCommunicationpreferencesGet200ResponseInner} and HTTP response
     */
    customersIdCommunicationpreferencesCommunicationpreferenceIdPutWithHttpInfo(id, communicationpreferenceId, customersIdCommunicationpreferencesCommunicationpreferenceIdPutRequest) {
      let postBody = customersIdCommunicationpreferencesCommunicationpreferenceIdPutRequest;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling customersIdCommunicationpreferencesCommunicationpreferenceIdPut");
      }
      // verify the required parameter 'communicationpreferenceId' is set
      if (communicationpreferenceId === undefined || communicationpreferenceId === null) {
        throw new Error("Missing the required parameter 'communicationpreferenceId' when calling customersIdCommunicationpreferencesCommunicationpreferenceIdPut");
      }
      // verify the required parameter 'customersIdCommunicationpreferencesCommunicationpreferenceIdPutRequest' is set
      if (customersIdCommunicationpreferencesCommunicationpreferenceIdPutRequest === undefined || customersIdCommunicationpreferencesCommunicationpreferenceIdPutRequest === null) {
        throw new Error("Missing the required parameter 'customersIdCommunicationpreferencesCommunicationpreferenceIdPutRequest' when calling customersIdCommunicationpreferencesCommunicationpreferenceIdPut");
      }

      let pathParams = {
        'id': id,
        'communicationpreferenceId': communicationpreferenceId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = CustomersIdCommunicationpreferencesGet200ResponseInner;
      return this.apiClient.callApi(
        '/customers/{id}/communicationpreferences/{communicationpreferenceId}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Update a communication preference for customer
     * Proxies `PUT /customers/{customerId}/communicationpreferences/{communicationpreferenceId}` to SSB
     * @param {Number} id Customer ID
     * @param {Number} communicationpreferenceId Communication Preference ID
     * @param {module:model/CustomersIdCommunicationpreferencesCommunicationpreferenceIdPutRequest} customersIdCommunicationpreferencesCommunicationpreferenceIdPutRequest Communication preference details to update
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/CustomersIdCommunicationpreferencesGet200ResponseInner}
     */
    customersIdCommunicationpreferencesCommunicationpreferenceIdPut(id, communicationpreferenceId, customersIdCommunicationpreferencesCommunicationpreferenceIdPutRequest) {
      return this.customersIdCommunicationpreferencesCommunicationpreferenceIdPutWithHttpInfo(id, communicationpreferenceId, customersIdCommunicationpreferencesCommunicationpreferenceIdPutRequest)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * Get communication preferences for customer
     * Proxies `GET /customers/{customerId}/communicationpreferences` to SSB
     * @param {Number} id SSB customer ID
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/CustomersIdCommunicationpreferencesGet200ResponseInner>} and HTTP response
     */
    customersIdCommunicationpreferencesGetWithHttpInfo(id) {
      let postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling customersIdCommunicationpreferencesGet");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = [CustomersIdCommunicationpreferencesGet200ResponseInner];
      return this.apiClient.callApi(
        '/customers/{id}/communicationpreferences', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Get communication preferences for customer
     * Proxies `GET /customers/{customerId}/communicationpreferences` to SSB
     * @param {Number} id SSB customer ID
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/CustomersIdCommunicationpreferencesGet200ResponseInner>}
     */
    customersIdCommunicationpreferencesGet(id) {
      return this.customersIdCommunicationpreferencesGetWithHttpInfo(id)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * Get a customer's full account summary
     * Returns the customer's account with all services, product instances and balances in a single call. 
     * @param {String} id The customer ID returned at login
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/CustomersIdGet200Response} and HTTP response
     */
    customersIdGetWithHttpInfo(id) {
      let postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling customersIdGet");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = CustomersIdGet200Response;
      return this.apiClient.callApi(
        '/customers/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Get a customer's full account summary
     * Returns the customer's account with all services, product instances and balances in a single call. 
     * @param {String} id The customer ID returned at login
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/CustomersIdGet200Response}
     */
    customersIdGet(id) {
      return this.customersIdGetWithHttpInfo(id)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * Get Stripe payment history for a customer
     * Returns a list of Stripe payment records for the customer over the past 12 months.
     * @param {String} id Customer's internal ID
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/CustomersIdPaymenthistoryGet200ResponseInner>} and HTTP response
     */
    customersIdPaymenthistoryGetWithHttpInfo(id) {
      let postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling customersIdPaymenthistoryGet");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = [CustomersIdPaymenthistoryGet200ResponseInner];
      return this.apiClient.callApi(
        '/customers/{id}/paymenthistory', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Get Stripe payment history for a customer
     * Returns a list of Stripe payment records for the customer over the past 12 months.
     * @param {String} id Customer's internal ID
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/CustomersIdPaymenthistoryGet200ResponseInner>}
     */
    customersIdPaymenthistoryGet(id) {
      return this.customersIdPaymenthistoryGetWithHttpInfo(id)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * Submit a trouble ticket
     * Sends a plain-text support ticket email to the provided recipient. Sender details (name and email) are retrieved from the customer's SSB personal details. 
     * @param {String} id The customer ID returned at login
     * @param {module:model/CustomersIdTicketPostRequest} customersIdTicketPostRequest 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/CustomersIdTicketPost200Response} and HTTP response
     */
    customersIdTicketPostWithHttpInfo(id, customersIdTicketPostRequest) {
      let postBody = customersIdTicketPostRequest;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling customersIdTicketPost");
      }
      // verify the required parameter 'customersIdTicketPostRequest' is set
      if (customersIdTicketPostRequest === undefined || customersIdTicketPostRequest === null) {
        throw new Error("Missing the required parameter 'customersIdTicketPostRequest' when calling customersIdTicketPost");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = CustomersIdTicketPost200Response;
      return this.apiClient.callApi(
        '/customers/{id}/ticket', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Submit a trouble ticket
     * Sends a plain-text support ticket email to the provided recipient. Sender details (name and email) are retrieved from the customer's SSB personal details. 
     * @param {String} id The customer ID returned at login
     * @param {module:model/CustomersIdTicketPostRequest} customersIdTicketPostRequest 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/CustomersIdTicketPost200Response}
     */
    customersIdTicketPost(id, customersIdTicketPostRequest) {
      return this.customersIdTicketPostWithHttpInfo(id, customersIdTicketPostRequest)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * Register a new prepaid customer via basket submission
     * Creates and submits a basket in SSB to provision a new prepaid customer in Odoo, then stores the resulting signup data in the cache under SIGNUP_DATA_<email>. Returns 409 if a signup record already exists for the email. 
     * @param {module:model/CustomersPostRequest} customersPostRequest 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
     */
    customersPostWithHttpInfo(customersPostRequest) {
      let postBody = customersPostRequest;
      // verify the required parameter 'customersPostRequest' is set
      if (customersPostRequest === undefined || customersPostRequest === null) {
        throw new Error("Missing the required parameter 'customersPostRequest' when calling customersPost");
      }

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = Object;
      return this.apiClient.callApi(
        '/customers', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Register a new prepaid customer via basket submission
     * Creates and submits a basket in SSB to provision a new prepaid customer in Odoo, then stores the resulting signup data in the cache under SIGNUP_DATA_<email>. Returns 409 if a signup record already exists for the email. 
     * @param {module:model/CustomersPostRequest} customersPostRequest 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
    customersPost(customersPostRequest) {
      return this.customersPostWithHttpInfo(customersPostRequest)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * Set password and activate a webshop customer account in SSB
     * Completes registration for a customer who went through the webshop signup flow (POST /customers). Requires a pending SIGNUP_DATA entry in the cache for the given email. Registers the user in SSB, sets their password, marks registered=true in the cache, and returns a ready-to-use session token. 
     * @param {module:model/CustomersRegisterPostRequest} customersRegisterPostRequest 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/CustomersRegisterPost201Response} and HTTP response
     */
    customersRegisterPostWithHttpInfo(customersRegisterPostRequest) {
      let postBody = customersRegisterPostRequest;
      // verify the required parameter 'customersRegisterPostRequest' is set
      if (customersRegisterPostRequest === undefined || customersRegisterPostRequest === null) {
        throw new Error("Missing the required parameter 'customersRegisterPostRequest' when calling customersRegisterPost");
      }

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = CustomersRegisterPost201Response;
      return this.apiClient.callApi(
        '/customers/register', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Set password and activate a webshop customer account in SSB
     * Completes registration for a customer who went through the webshop signup flow (POST /customers). Requires a pending SIGNUP_DATA entry in the cache for the given email. Registers the user in SSB, sets their password, marks registered=true in the cache, and returns a ready-to-use session token. 
     * @param {module:model/CustomersRegisterPostRequest} customersRegisterPostRequest 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/CustomersRegisterPost201Response}
     */
    customersRegisterPost(customersRegisterPostRequest) {
      return this.customersRegisterPostWithHttpInfo(customersRegisterPostRequest)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * Get subscription by customer email
     * Returns subscription information for a given email address.
     * @param {String} email Customer's email address
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/CustomersSubscriptionGet200Response} and HTTP response
     */
    customersSubscriptionGetWithHttpInfo(email) {
      let postBody = null;
      // verify the required parameter 'email' is set
      if (email === undefined || email === null) {
        throw new Error("Missing the required parameter 'email' when calling customersSubscriptionGet");
      }

      let pathParams = {
      };
      let queryParams = {
        'email': email
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = CustomersSubscriptionGet200Response;
      return this.apiClient.callApi(
        '/customers/subscription', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Get subscription by customer email
     * Returns subscription information for a given email address.
     * @param {String} email Customer's email address
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/CustomersSubscriptionGet200Response}
     */
    customersSubscriptionGet(email) {
      return this.customersSubscriptionGetWithHttpInfo(email)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * Activate subscription
     * Activates a subscription and clears related cached data by email.
     * @param {module:model/CustomersSubscriptionsActivatePostRequest} customersSubscriptionsActivatePostRequest 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/CustomersSubscriptionsActivatePost200Response} and HTTP response
     */
    customersSubscriptionsActivatePostWithHttpInfo(customersSubscriptionsActivatePostRequest) {
      let postBody = customersSubscriptionsActivatePostRequest;
      // verify the required parameter 'customersSubscriptionsActivatePostRequest' is set
      if (customersSubscriptionsActivatePostRequest === undefined || customersSubscriptionsActivatePostRequest === null) {
        throw new Error("Missing the required parameter 'customersSubscriptionsActivatePostRequest' when calling customersSubscriptionsActivatePost");
      }

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = CustomersSubscriptionsActivatePost200Response;
      return this.apiClient.callApi(
        '/customers/subscriptions/activate', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Activate subscription
     * Activates a subscription and clears related cached data by email.
     * @param {module:model/CustomersSubscriptionsActivatePostRequest} customersSubscriptionsActivatePostRequest 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/CustomersSubscriptionsActivatePost200Response}
     */
    customersSubscriptionsActivatePost(customersSubscriptionsActivatePostRequest) {
      return this.customersSubscriptionsActivatePostWithHttpInfo(customersSubscriptionsActivatePostRequest)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * Get pending change plan
     * Returns pending change-plan info for a customer email.
     * @param {String} email Customer email address
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/CustomersSubscriptionsChangePlanGet200Response} and HTTP response
     */
    customersSubscriptionsChangePlanGetWithHttpInfo(email) {
      let postBody = null;
      // verify the required parameter 'email' is set
      if (email === undefined || email === null) {
        throw new Error("Missing the required parameter 'email' when calling customersSubscriptionsChangePlanGet");
      }

      let pathParams = {
      };
      let queryParams = {
        'email': email
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = CustomersSubscriptionsChangePlanGet200Response;
      return this.apiClient.callApi(
        '/customers/subscriptions/change-plan', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Get pending change plan
     * Returns pending change-plan info for a customer email.
     * @param {String} email Customer email address
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/CustomersSubscriptionsChangePlanGet200Response}
     */
    customersSubscriptionsChangePlanGet(email) {
      return this.customersSubscriptionsChangePlanGetWithHttpInfo(email)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * Get pending subscription by customer email
     * Returns pending subscription information for a given email address.
     * @param {String} email Customer's email address
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/CustomersSubscriptionsPendingGet200Response} and HTTP response
     */
    customersSubscriptionsPendingGetWithHttpInfo(email) {
      let postBody = null;
      // verify the required parameter 'email' is set
      if (email === undefined || email === null) {
        throw new Error("Missing the required parameter 'email' when calling customersSubscriptionsPendingGet");
      }

      let pathParams = {
      };
      let queryParams = {
        'email': email
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = CustomersSubscriptionsPendingGet200Response;
      return this.apiClient.callApi(
        '/customers/subscriptions/pending', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Get pending subscription by customer email
     * Returns pending subscription information for a given email address.
     * @param {String} email Customer's email address
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/CustomersSubscriptionsPendingGet200Response}
     */
    customersSubscriptionsPendingGet(email) {
      return this.customersSubscriptionsPendingGetWithHttpInfo(email)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * Register or deregister account
     * Register or deregister subscription in the app.
     * @param {module:model/CustomersSubscriptionsRegisterPutRequest} customersSubscriptionsRegisterPutRequest 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/CustomersSubscriptionsRegisterPut200Response} and HTTP response
     */
    customersSubscriptionsRegisterPutWithHttpInfo(customersSubscriptionsRegisterPutRequest) {
      let postBody = customersSubscriptionsRegisterPutRequest;
      // verify the required parameter 'customersSubscriptionsRegisterPutRequest' is set
      if (customersSubscriptionsRegisterPutRequest === undefined || customersSubscriptionsRegisterPutRequest === null) {
        throw new Error("Missing the required parameter 'customersSubscriptionsRegisterPutRequest' when calling customersSubscriptionsRegisterPut");
      }

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = CustomersSubscriptionsRegisterPut200Response;
      return this.apiClient.callApi(
        '/customers/subscriptions/register', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Register or deregister account
     * Register or deregister subscription in the app.
     * @param {module:model/CustomersSubscriptionsRegisterPutRequest} customersSubscriptionsRegisterPutRequest 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/CustomersSubscriptionsRegisterPut200Response}
     */
    customersSubscriptionsRegisterPut(customersSubscriptionsRegisterPutRequest) {
      return this.customersSubscriptionsRegisterPutWithHttpInfo(customersSubscriptionsRegisterPutRequest)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * Update customer's subscription settings
     * Updates the `autoRenew` flag for a customer's subscription and persists it in cache.
     * @param {module:model/UpdateSubscriptionRequest} updateSubscriptionRequest 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/UpdateSubscription200Response} and HTTP response
     */
    updateSubscriptionWithHttpInfo(updateSubscriptionRequest) {
      let postBody = updateSubscriptionRequest;
      // verify the required parameter 'updateSubscriptionRequest' is set
      if (updateSubscriptionRequest === undefined || updateSubscriptionRequest === null) {
        throw new Error("Missing the required parameter 'updateSubscriptionRequest' when calling updateSubscription");
      }

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = UpdateSubscription200Response;
      return this.apiClient.callApi(
        '/customers/subscription', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Update customer's subscription settings
     * Updates the `autoRenew` flag for a customer's subscription and persists it in cache.
     * @param {module:model/UpdateSubscriptionRequest} updateSubscriptionRequest 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/UpdateSubscription200Response}
     */
    updateSubscription(updateSubscriptionRequest) {
      return this.updateSubscriptionWithHttpInfo(updateSubscriptionRequest)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


}
